import { faCircleCheck } from "@fortawesome/free-solid-svg-icons/faCircleCheck";
import { faPause } from "@fortawesome/free-solid-svg-icons/faPause";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import type { IMerchantFormatterProps } from "src/merchants/formatters/MerchantFormatters";

export interface MerchantSuspendedProps extends IMerchantFormatterProps {
  showsText?: boolean;
}

export const MerchantSuspended = ({
  children: { isSuspended },
  showsText = true,
}: MerchantSuspendedProps) => {
  const intl = useIntl();
  if (isSuspended) {
    return (
      <span>
        <FontAwesomeIcon
          icon={faPause}
          className="text-secondary"
          title={intl.formatMessage({ id: "merchants.suspended.inactive" })}
        />
        {showsText && (
          <>
            {" "}
            <FormattedMessage id="merchants.suspended.inactive" />
          </>
        )}
      </span>
    );
  }
  return (
    <span>
      <FontAwesomeIcon
        icon={faCircleCheck}
        className="text-success"
        title={intl.formatMessage({ id: "merchants.suspended.active" })}
      />
      {showsText && (
        <>
          {" "}
          <FormattedMessage id="merchants.suspended.active" />
        </>
      )}
    </span>
  );
};
